import { EllipseIcon } from "../icon/EllipseIcon";
import { Body14Medium } from "../typography/Body14Medium";
import { Footnote12Description } from "../typography/Footnote12Description";

interface Props {
  className?: string;
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
  style?: React.CSSProperties;
}

export const TextInputLabel: React.FC<Props> = ({
  children,
  className,
  required,
  htmlFor,
  style,
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`${required ? "gap-[2px]" : "gap-[4px]"} flex mb-[8px]`}
      style={style}
    >
      <Body14Medium className={`text-semantic-text-heading ${className ?? ""}`}>
        {children}
      </Body14Medium>
      {required ? (
        <div className="w-[8px] h-[8px] flex items-end justify-start text-semantic-text-error-primary text-[2px]">
          <EllipseIcon size={2} color="text-semantic-text-error-primary" />
        </div>
      ) : (
        !htmlFor && ( // htmlFor이 없을 때만 "선택" 텍스트 표시
          <div className="flex items-center mt-[2px]">
            <Footnote12Description className="text-semantic-text-tertiary">
              선택
            </Footnote12Description>
          </div>
        )
      )}
    </label>
  );
};
